// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Minimal service worker (public/sw.js) so Chrome offers Install.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// NOTE: the original admin-portal registered a PWA service worker here
// (service-worker.js). That file wasn't part of the source backup, so
// it's omitted for now rather than registering a path that 404s. Add it
// back later if PWA install-to-homescreen is wanted for this portal.
